module.exports = "https://cdn-static.kwai.net/kos/s101/nlav11312/shop/c_krn/krn-web/images/closeWithBackground.a15e7c3629.png";